import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import TitleAndDescription from '../title-and-description'
import ParkingZone from './parking-zone'
import style from './index.scss'

export const parkingZones = ({ carParks, centre, noBorder }) =>
  (Array.isArray(carParks) ? carParks : [])
    .slice()
    .map(carPark => (
      <ParkingZone
        className={noBorder ? '' : style.parkingZoneBorder}
        key={carPark.sys.id}
        carParkName={carPark.title}
        carParkLocation={carPark.location}
        carParkEntrance={carPark.entrance}
        bestParkingFor={
          carPark.bestParkingForCollection
            ? carPark.bestParkingForCollection.items
            : carPark.bestParkingFor
        }
        latitude={carPark.latitude}
        longitude={carPark.longitude}
        centreSlug={centre.slug}
      />
    ))

const getMetaData = ({ centre }) => ({
  title: `Westfield ${centre.title} Parking | Parking Rates & Fees`,
  description: `Westfield ${centre.title} offers you secure car parking. Check parking information including entrances, hourly rates and more at Westfield ${centre.title} `,
})

const Parking = ({ carParks, centre }) => (
  <Fragment>
    <TitleAndDescription getMetaData={getMetaData} centre={centre} />
    {parkingZones({ carParks, centre, noBorder: false })}
  </Fragment>
)

Parking.propTypes = {
  carParks: PropTypes.array,
  centre: PropTypes.object,
}

export default Parking
